export default "__VITE_ASSET__fdad034d__"